import styles from "./user.module.css";
import { useCallback, useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/userContext";
import { apiConfig } from "../../commonFunction/apiconfig";
import axios from "axios";
import Loader from "../../components/loader";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import "../withdraw/pagination.css";

export default function PlanDataCompleted() {
  const navigate = useNavigate();
  const { userToken } = useContext(UserContext);
  const [data, setData] = useState([]);

  const [parameter] = useState({
    fromDate: "",
    toDate: "",
    search: "",
    planSubscription: "",
    type: "All",
    limit: 20,
    sorttype: "",
  });
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };
  const getUsers = useCallback(async () => {
    if (userToken === "") return;
    try {
      const headers = {
        token: userToken,
      };
      setLoading(true);
      const res = await axios.get(
        `${apiConfig.planData}?page=${currentPage}&search=${parameter?.search}&fromDate=${parameter?.fromDate}&toDate=${parameter?.toDate}&type=${parameter?.type}&limit=${parameter.limit}&status=COMPLETED`,
        { headers }
      );
      setLoading(false);
      const responseGroups = res?.data?.result[0]?.data || [];
      setData(responseGroups);
      setTotalPages(res?.data?.result[0]?.metadata[0]?.total_page);
    } catch (error) {
      console.log(error);
      setData([]);
      setLoading(false);
      if (error?.response?.data?.statusCode === 400) {
        localStorage.clear();
        navigate("/login");
      }
    }
  }, [currentPage, navigate, parameter, userToken]);

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  return (
    <div className={styles?.userContainer}>
      <h1 className={styles?.userContainerHeading}>Plan Data Completed</h1>
      {loading ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            placeContent: "center",
            marginTop: "100px",
          }}
        >
          <Loader width="100px" height="100px" />
        </div>
      ) : (
        <>
          {!data || data.length === 0 ? (
            <p
              style={{
                textAlign: "center",
                marginTop: "40px",
                fontWeight: "bold",
              }}
            >
              No Data Found
            </p>
          ) : (
            <div className={styles.tableWrallerUser}>
              <table>
                <tr>
                  <th className={styles.flexTableData}>No.</th>
                  <th>IVT ID</th>
                  <th>Plan</th>
                  <th>Amount</th>
                </tr>
                {data &&
                  data.map((item, index) => {
                    return (
                      <tr>
                        <td key={index}>{index + 1}</td>
                        <td>{item?._id ? item?._id : "NA"}</td>
                        <td>
                          {item?.plans?.map((plan, idx) => (
                            <div key={idx}>
                              {plan?.userName} / {plan?.plan} / {plan?.amount} /
                              {plan?.purchasedOn}
                            </div>
                          ))}
                        </td>
                        <td>{item?.totalAmount ? item?.totalAmount : "NA"}</td>
                      </tr>
                    );
                  })}
              </table>
            </div>
          )}
          {(data || !data?.length === 0) && (
            <ReactPaginate
              previousLabel={"Prev"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
              disabledClassName={"disabled"}
              breakClassName={"ellipsis"}
              pageClassName={"page-item"}
              previousClassName={"previous"}
              nextClassName={"next"}
              forcePage={currentPage - 1}
            />
          )}
        </>
      )}
    </div>
  );
}
